export const timeframes = [
  {
    id: "15m",
    label: "15m",
    range: 60 * 15,
    interval: 60
  },
  {
    id: "1h",
    label: "1h",
    range: 60 * 60,
    interval: 60
  },
  {
    id: "8h",
    label: "8hrs",
    range: 60 * 60 * 8,
    interval: 60 * 10
  },
  {
    id: "24h",
    label: "24hrs",
    range: 60 * 60 * 24,
    interval: 60 * 10
  }
] as const;

export const gridTimeframes = [
  {
    id: "15m",
    label: "15m",
    range: 60 * 15,
    interval: 60
  },
  {
    id: "1h",
    label: "1h",
    range: 60 * 60,
    interval: 60
  },
  {
    id: "8h",
    label: "8hrs",
    range: 60 * 60 * 8,
    interval: 60 * 10
  },
  {
    id: "24h",
    label: "24hrs",
    range: 60 * 60 * 24,
    interval: 60 * 10
  }
];

export const defaultPollTime = {
  "15m": "1m",
  "1h": "5m",
  "8h": "10m",
  "24h": "20m",
  fallback: "20m"
};

export const GRID_QUERY = [
  {
    name: "cpu.value",
    expr: "SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'service', 'instance')"
  },
  {
    name: "cpu.percentage",
    expr: "100 * SUM((`cpu.user` + `cpu.kernel`) / (`interval` * `cpu.cores`), 'service', 'instance')"
  },
  {
    name: "cpu.max",
    expr: "`cpu.cores`"
  },
  {
    name: "cpu.average.value",
    expr: "AVG(SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'service', 'instance'), 'service')"
  },
  {
    name: "cpu.average.percentage",
    expr: "AVG(100 * SUM((`cpu.user` + `cpu.kernel`) / (`interval` * `cpu.cores`), 'service', 'instance'), 'service')"
  },
  {
    name: "memory.value",
    expr: "SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'service', 'instance')"
  },
  {
    name: "memory.percentage",
    expr: "100 * SUM((`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'service', 'instance')"
  },
  {
    name: "memory.max",
    expr: "`memory.limit`"
  },
  {
    name: "memory.average.value",
    expr: "AVG(SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'service', 'instance'), 'service')"
  },
  {
    name: "memory.average.percentage",
    expr: "AVG(100 * SUM((`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'service', 'instance'), 'service')"
  },
  {
    name: "disk.value",
    expr: "`disk.space.used`"
  },
  {
    name: "disk.percentage",
    expr: "100 * (`disk.space.used`/`disk.space.limit`)"
  },
  {
    name: "disk.max",
    expr: "AVG(`disk.space.limit`, 'mountpoint', 'service', 'instance')"
  },
  {
    name: "disk.average.value",
    expr: "AVG(`disk.space.used`, 'mountpoint', 'service')"
  },
  {
    name: "disk.average.percentage",
    expr: "AVG(100*(`disk.space.used`/`disk.space.limit`), 'mountpoint', 'service')"
  }
];

export const DG3_QUERY = [
  {
    name: "cpu.average.value",
    expr: "AVG(SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'hostname', 'service', 'instance'), 'service')"
  },
  {
    name: "cpu.average.percentage",
    expr: "AVG(100 * SUM((`cpu.user` + `cpu.kernel`) / (`interval` * `cpu.cores`), 'hostname', 'service', 'instance'), 'service')"
  },
  {
    name: "cpu.value",
    expr: "SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'hostname', 'service', 'instance')"
  },
  {
    name: "cpu.percentage",
    expr: "SUM(100 * (`cpu.user` + `cpu.kernel`) / (`interval` * `cpu.cores`), 'hostname', 'service', 'instance')"
  },
  {
    name: "cpu.max",
    expr: "`cpu.cores`"
  },
  {
    name: "memory.average.value",
    expr: "AVG(SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'hostname', 'service', 'instance'), 'service')"
  },
  {
    name: "memory.average.percentage",
    expr: "AVG(SUM(100 * (`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'hostname', 'service', 'instance'), 'service')"
  },
  {
    name: "memory.value",
    expr: "SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'hostname', 'service', 'instance')"
  },
  {
    name: "memory.percentage",
    expr: "SUM(100 * (`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'hostname', 'service', 'instance')"
  },
  {
    name: "memory.max",
    expr: "`memory.limit`"
  },
  {
    name: "disk.average.value",
    expr: "AVG(`disk.space.used`, 'mountpoint', 'service')"
  },
  {
    name: "disk.average.percentage",
    expr: "AVG((`disk.space.used`/`disk.space.limit`)*100, 'mountpoint', 'service')"
  },
  {
    name: "disk.value",
    expr: "`disk.space.used`"
  },
  {
    name: "disk.percentage",
    expr: "(`disk.space.used`/`disk.space.limit`)*100"
  },
  {
    name: "disk.max",
    expr: "AVG(`disk.space.limit`, 'mountpoint', 'service', 'instance')"
  }
];

export const DG2_QUERY = [
  {
    name: "cpu.average-value",
    expr: "AVG(SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'hostname'))"
  },
  {
    name: "cpu.average-percentage",
    expr: "AVG(100 * SUM((`cpu.user` + `cpu.kernel`) / (`interval` * `cpu.cores`), 'hostname'))"
  },
  {
    name: "cpu.value",
    expr: "SUM((`cpu.user` + `cpu.kernel`) / `interval`, 'hostname')"
  },
  {
    name: "cpu.percentage",
    expr: "SUM(100 * (`cpu.user` + `cpu.kernel`) / ( `interval` * `cpu.cores`), 'hostname')"
  },
  {
    name: "cpu.max",
    expr: "MAX(`cpu.cores`)"
  },
  {
    name: "memory.average-value",
    expr: "AVG(SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'hostname'))"
  },
  {
    name: "memory.average-percentage",
    expr: "AVG(SUM(100 * (`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'hostname'))"
  },
  {
    name: "memory.value",
    expr: "SUM(`memory.apps` + `memory.kernel` + `memory.buffers`, 'hostname')"
  },
  {
    name: "memory.percentage",
    expr: "SUM(100 * (`memory.apps` + `memory.kernel` + `memory.buffers`) / `memory.limit`, 'hostname')"
  },
  {
    name: "memory.max",
    expr: "MAX(`memory.limit`)"
  },
  {
    name: "disk.average-value",
    expr: "AVG(`disk.space.used`, 'mountpoint')"
  },
  {
    name: "disk.average-percentage",
    expr: "AVG((`disk.space.used`/`disk.space.limit`)*100, 'mountpoint')"
  },
  {
    name: "disk.value",
    expr: "`disk.space.used`"
  },
  {
    name: "disk.percentage",
    expr: "(`disk.space.used`/`disk.space.limit`)*100"
  },
  {
    name: "disk.max",
    expr: "AVG(`disk.space.limit`, 'mountpoint')"
  }
];
